import React from 'react';
import { CSpinner } from '@coreui/react';

interface ILoadingProps {
  blocking?: boolean;
}

export const Loading: React.FunctionComponent<ILoadingProps> = ({ blocking = true }) => {
  return (
    <div className={`loading ${blocking ? 'block-loading' : ''}`}>
      <CSpinner color="primary" />
    </div>
  );
}
